// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Mlb4","controls":"styles_controls__EVLQu","charLimit":"styles_charLimit__3wLCW","input":"styles_input__1pSyq","send":"styles_send__kvEuc"};